'use strict';

var ROMSummaryKpiReferenceFilterFactory = function ROMSummaryKpiReferenceFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMSummaryCabinFilterFactory', 'ROMSummaryPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ROMSummaryKpiReferenceFilter() {
    DemandFilter.call(this, ['rom-summary-reference-mode'], ['kpi-ribbon-reference']);
    this.registerFilters(injectedFilters);
  }
  ROMSummaryKpiReferenceFilter.constructor = ROMSummaryKpiReferenceFilter;
  ROMSummaryKpiReferenceFilter.prototype = Object.create(DemandFilter.prototype);
  ROMSummaryKpiReferenceFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return ROMSummaryKpiReferenceFilter;
};
ROMSummaryKpiReferenceFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ROMSummaryKpiReferenceFilterFactory;